import { render } from "./PartnershipDetail.vue?vue&type=template&id=ce082c4e&scoped=true&ts=true"
import script from "./PartnershipDetail.vue?vue&type=script&lang=ts"
export * from "./PartnershipDetail.vue?vue&type=script&lang=ts"

import "./PartnershipDetail.vue?vue&type=style&index=0&id=ce082c4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce082c4e"]])

export default __exports__